import gql from "graphql-tag";

export default gql`
  mutation UpdateContract($contractInput: ContractInputInput, $customerId: ID, $contractId: ID) {
    updateContract(contractInput: $contractInput, customerId: $customerId, contractId: $contractId) {
      id
    }
  }
`;
